import { css, SerializedStyles, Theme } from '@emotion/react'

export const TextColorTheme = (props: { theme: Theme }): SerializedStyles => css`
	color: ${props.theme.text.color};
`
